require('./brands.less');
require('filterizr/dist/jquery.filterizr.min.js');

/**
 * Метод возвращает верстку с отфильтрованными брендами
 *
 * @param query - строка GET-запросом, по которому будет генерироваться фильтр элементов
 */
function getElementsOfFilter(query) {
    if (query === false) {
        query = '';
    } else {
        query = '?' + query;
    }
    $.ajax({
        url: '/ajax/component/maximaster:brands/.default/' + query,
        cache: false,
        success: function(JSON) {
            var div = document.createElement('div');
            div.innerHTML = JSON.html;
            var brands = $(div)
                .find('.grid__item--5col-x4')
                .get(0);
            $('.grid__item--5col-x4').html(brands.innerHTML);

            $('.js-brands-list').filterizr({
                selector: '.js-brands-list',
                animationDuration: 0.45,
                delayTimeout: 500
            });
        }
    });
}

jQuery(function() {
    $('.js-brands-list').filterizr({
        selector: '.js-brands-list',
        animationDuration: 0.45,
        delayTimeout: 500
    });

    var $arFilters = [];
    var $queryFirstLetter;
    var $queryCategories = '';

    //Формируем фильтр по алфавитному указателю
    $(document).on('click', '.js-brands-filter-btn', function() {
        var $this = $(this);
        var curIndex = $this.data('filter');
        var $filterBtns = $('.js-brands-filter-btn');

        $filterBtns.filter('[data-filter=' + curIndex + ']').addClass('letters__item--current');
        $filterBtns.not('[data-filter=' + curIndex + ']').removeClass('letters__item--current');

        //Формируе запрос по алфавитному указателю
        $queryFirstLetter = 'F_LETTER=' + $this.data('filter');

        //Подтягиваем новую вёрстку после применения фильтра
        getElementsOfFilter($queryFirstLetter + '&' + $queryCategories);
    });

    //Формируем фильтр по секциям левого сайдбара
    $('.filter__variants').on('click', 'input', function() {
        var $this = $(this);

        if ($this.prop('checked')) {
            $arFilters.push($this.data('category'));

            $queryCategories = 'F_CATEGORY=';

            $arFilters.forEach(function($category) {
                $queryCategories += $category + '$';
            });
        } else {
            $queryCategories = $queryCategories.replace($this.data('category'), '');
            $arFilters.splice($arFilters.indexOf($this), 1);
        }
        //Подтягиваем новую вёрстку после применения фильтра
        getElementsOfFilter($queryFirstLetter + '&' + $queryCategories);
    });

    $(document).on('click', 'form input[type=reset]', function() {
        var $filterBtns = $('.js-brands-filter-btn');
        $queryFirstLetter = '';
        $queryCategories = '';
        $filterBtns.removeClass('letters__item--current');
        $('.filter__variants').prop('checked', false);
        getElementsOfFilter(false);
    });
});



// WEBPACK FOOTER //
// ./blocks/brands/brands.js